import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux';
import {Link} from 'react-router-dom';
import { getTrashedCount } from '../../actions';

export class Trashed extends Component {
  static contextTypes = {formatMessage: PropTypes.any};
  componentDidMount(){
    this.props.getTrashedCount()
  }

  render() {
    const {formatMessage} = this.context;
    const {trashed_count} = this.props;
    return (
      <Link to='/card_trashed' className="qbm-accordion-component">
        <div className="qbm-accordion-title">
          {formatMessage('titleCardTrashed')}
          <div>({trashed_count})</div>
        </div>
      </Link>
    )
  }
}

const mapStateToProps = (state) => ({
  trashed_count: state.card.trashed_count,
})

const mapDispatchToProps = {
  getTrashedCount
}

export default connect(mapStateToProps, mapDispatchToProps)(Trashed)



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Card/components/Trashed/Trashed.jsx